import { useContext } from 'react';

import { BoardContextValue } from '@v2/pages/planboard/components/Board/web/types';
import { BoardContext } from './context';

export const useBoardContext: () => BoardContextValue = () => {
  const value = useContext(BoardContext);

  if (!value) {
    throw new Error('useBoardContext must be used within BoardContext.Provider');
  }

  return value;
};
